export function addIgnores(ignoreChars) {
  return ignoreChars.map(char => `${char}?`).join('');
}
export const sanitizeTerm = (term) => {
  return term === null || term === void 0 ? void 0 : term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};
export const ignoreSpecialChars = (ignoreChars) => (term) => {
  return Array.from(term)
    .map(sanitizeTerm)
    .map(char => `${char}${addIgnores(ignoreChars)}`).join('');
};
export const matchReplacer = (tag) => (match) => tag ? `<${tag} class="matched">${match}</${tag}>` : match;
//# sourceMappingURL=matcher-utils.js.map
